@if (hasSearchStarted) {


@if (isMapAvailable) {
    <app-tours-map [class.hidden]="isShowMap || isShowTourLoader"/>
}
<div [class.hidden]="isMapAvailable && !isShowMap && !isShowTourLoader">
@if ((toursNotFound$ | async) === true && !isShowTourLoader) {
    <app-tours-not-found type="find-tours"/>
} @else {
    <div id="siteFindTours" class="find-tours-listing">
        <app-search-progress-linear [type]="'line-note'" />
        <app-guide-banners></app-guide-banners>
        @if (isShowTourLoader) {
            <app-tours-skeleton/>
        }
        <app-tours/>
    </div>
}
</div>

}
